import React, { ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'zustand';
import { calendarStore } from 'entities/calendar';
import { useDebounceFunction } from 'shared/lib/debounce';
import { SearchInput } from 'shared/ui/SearchInput';

const CalendarsSearchInput = (): ReactElement => {
  const { t } = useTranslation();
  const { searchQuery, setSearchQuery } = useStore(calendarStore);

  const [localSearch, setLocalSearch] = useState(searchQuery);

  const debouncedSearchHandler = useDebounceFunction(setSearchQuery, 500);

  useEffect(() => {
    if (searchQuery === '') setLocalSearch(searchQuery);
  }, [searchQuery]);

  return (
    <SearchInput
      value={localSearch}
      onChange={(e) => {
        setLocalSearch(e.currentTarget.value);
        debouncedSearchHandler(e.currentTarget.value);
      }}
      placeholder={t('Calendar:page.tabs.leftWidget.search.placeholder')}
      allowClear
      onReset={() => {
        setSearchQuery('');
      }}
    />
  );
};

export default CalendarsSearchInput;
